import {Component, Input} from '@angular/core';

@Component({
  selector: 'util-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent {

  @Input() size: number = 50
  @Input() padding: number = 20

  @Input() bar = false
  @Input() determinate = false
  @Input() determinateValue: number = 0

  @Input() message: string | null = null

  constructor() {
  }

  ngOnInit(): void {
  }

}
